<div class="metric-container" [style.width.px]="metricReferencePix">
  <span [matTooltip]="'alert.metric_reference' | translate"
    >{{ metricReference }} <i class="ri-error-warning-line text-warning"></i
  ></span>
</div>
